import React from 'react'

// Two/three-way selector, styled like the site's inputs.
// options: [{value, label, disabled, note}]
export default function ToggleInput({label, options, VS, setVS}) {
    return (
        <div className='iolx-toggle-group'>
            <span className='controlLabel iolx-label'
            style={{display: (label === '')? 'none' : null}}>{label}</span>
            <div className='iolx-toggle'>
                {options.map((option) =>
                    <span key={option.value}
                    className={'iolx-toggle-option'
                        + ((VS[0] === option.value)? ' selected' : '')
                        + ((option.disabled)? ' disabled' : '')}
                    title={option.note? option.note : null}
                    onClick={() => {
                        if(option.disabled) return;
                        setVS([option.value, 1]);
                    }}>
                        {option.label}
                        {(option.note)?
                            <span className='iolx-toggle-note'>{option.note}</span>
                        : null}
                    </span>
                )}
            </div>
        </div>
    )
}
